export default __webpack_public_path__ + "static/media/creditcard-3-1.65781676.svg";